/**
 * Sidebar Module
 */

import { adminMenus } from './adminMenus'
import { clientMenus } from './clientMenus'
import { cashierMenus } from './cashierMenus'
import { deliveryMenus } from './deliveryMenus'
import ticketMasterMenus from "./ticketMasterMenus"
const state = {
    menus: []
}

const roles = {
    ADMIN: 1,
    CLIENT: 2,
    CASHIER: 3,
    DELIVERY: 4,
    TICKETMASTER: 5
}

const getters = {
    menus: (state, getters, rootState, rootGetters) => {
        switch (rootGetters.getUser.role_id) {

            case roles.ADMIN:
                return adminMenus

            case roles.CLIENT:
                return clientMenus

            case roles.CASHIER:
                return cashierMenus

            case roles.DELIVERY:
                return deliveryMenus
            case roles.TICKETMASTER:
                return ticketMasterMenus
        }

        //return rootGetters.getUser.role_id === 1 ? adminMenus : clientMenus;
    }
}

const actions = {
    setActiveMenuGroup(context, payload) {
        context.commit('setActiveMenuGroupHandler', payload);
    }
}

const mutations = {
    setActiveMenuGroupHandler(state, router) {
        let fullPath = '';
        if (router.pathURL) {
            fullPath = router.pathURL;
        } else {
            fullPath = router.history.current.fullPath;
        }
        let path = fullPath.split('/');
        let matchedPath = '/' + path[2] + '/' + path[3];
        // for (const category in state.menus) {
        //     for (const menuGroup in state.menus[category]) {
        //         if (state.menus[category][menuGroup].items !== null) {
        //             for (const matched in state.menus[category][menuGroup].items) {
        //                 if (state.menus[category][menuGroup].items[matched].path == matchedPath || state.menus[category][menuGroup].items[matched].path == fullPath) {
        //                     state.menus[category][menuGroup].active = true;
        //                 }
        //             }
        //         }
        //     }
        // }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}